import { EnumPriceTierPriceType, Product } from "gql/generated";

export const getLowestNightlyPrice = (pricing: Product["pricing"]) => {
  const isPerGuestPricing = pricing?.tiers.some(
    tier => tier?.priceType === EnumPriceTierPriceType.PerGuest,
  );
  const lowestNightlyPrice = isPerGuestPricing
    ? (pricing?.tiers.reduce((min, tier) => {
        if (!tier) return min;

        const minNightlyPrice = min;
        const tierNightlyPrice = tier.price * (tier.guestCountForPrice ?? 0);
        const lowestNightlyPrice = Math.min(minNightlyPrice, tierNightlyPrice);

        if (tier && lowestNightlyPrice === tierNightlyPrice) {
          return tierNightlyPrice;
        } else return min;
      }, Infinity) ?? 0)
    : 0;

  return lowestNightlyPrice;
};
